import { BaseScatola } from '@lucan/base-ui'
import { createContext, useContext, useEffect, useState } from 'react'

// Unico contesto globale
const AppContext = createContext(null)

function GlobalContext({ children, configurazione }) {
  const {
    messaggio,
    lingue,
    valutazione = null,
    idCliente = null,
    intermediario = false,
    uri,
    cmd = null
  } = configurazione
 
  const [lingua, setLingua] = useState('it')
  
  // Contesto unico, contiene tutti i valori
  const contextValue = {
    uri,
    lingue,
    lingua,
    setLingua,
    valutazione,
    idCliente,
    intermediario,
    cmd
  }

  return (
    <AppContext.Provider value={contextValue}>
      {messaggio ?(
        <Error messaggio={messaggio} />
      ):(<>{children}</>) }      
      
    </AppContext.Provider>
  )
}

// Hook unico per accedere a tutto
function useAppContext() {
  return useContext(AppContext)

}

function Error({messaggio}) {


  useEffect(() => {
    const loader = document.getElementById('app-loader')
    if (loader) loader.remove()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return(<BaseScatola errore>{messaggio}</BaseScatola>)
}
// eslint-disable-next-line react-refresh/only-export-components
export { GlobalContext, useAppContext }
